import(/* webpackMode: "eager" */ "/tmp/build_324ff5f6/apps/sales-pilot-sites/src/app/global-error.tsx");
